/**
 * Created by simon zhao on 9/19/2022.
 * Description:
 * NoteDepositTriggerMetaDialog Service
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NoteDepositTriggerMetaDialogOptions, NoteDepositTriggerMetaDialogResult } from './note-deposit-trigger-meta-dialog.model';

@Injectable()
export class NoteDepositTriggerMetaDialogService {

    dialogClose$: Subject<NoteDepositTriggerMetaDialogResult> = new Subject<NoteDepositTriggerMetaDialogResult>();
    dialogOpen$: Subject<NoteDepositTriggerMetaDialogOptions> = new Subject<NoteDepositTriggerMetaDialogOptions>();
}
